import { Component, OnInit, ViewChild } from '@angular/core';
import { IonContent, ModalController, NavParams, ToastController } from '@ionic/angular';
import { Platform } from '@ionic/angular';
import { AppEnum } from 'src/app/appenum';
import { EncryptionService } from 'src/app/services/encryption.service';
import { PermissionService } from 'src/app/services/permission.service';
import { take } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { AppSettings } from 'src/app/app.settings';
import { AppService } from 'src/app/services/app.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { wrapAllMethodsWithLogging } from 'src/app/core/decorators/log-all-errors.decorator';
import { LoggingService } from 'src/app/services/logging.service';


@Component({
  selector: 'app-model-popup',
  templateUrl: './model-popup.component.html',
  styleUrls: ['./model-popup.component.scss'],
  standalone: false
})
export class ModelPopupComponent implements OnInit {
  permissionDenied$: Observable<boolean>;
  @ViewChild(IonContent) content!: IonContent;
  key: any;
  addresses: any = [];  // Array to store all addresses
  subObjects = [
    { name: 'Kitchen', checked: false },
    { name: 'Bathroom', checked: false },
    { name: 'Bedroom', checked: false },
    { name: 'Plumbing', checked: false },
    { name: 'Pool', checked: false },
    { name: 'Hall', checked: false },
    { name: 'Lawn', checked: false },
    { name: 'Backyard', checked: false },
    { name: 'Dining room', checked: false },
    { name: 'Lobby', checked: false }
  ];
  tabs: any = [];

  platform: 'android' | 'ios' | 'unknown' = 'unknown';
  browserType: any;
  showGif: boolean = false;
  index: number = 0;
  selectedTabIndex = 0;
  steps: boolean = true;
  tryAgainGuide: boolean = false;
  componentName: string = 'model-popup';
  constructor(public modalCtrl: ModalController, private navParams: NavParams,
    private platformService: Platform,
    private sanitizer: DomSanitizer,
    private translate: TranslateService,
    private encryptionService: EncryptionService,
    public permissionService: PermissionService,
    private _appenum: AppEnum,
    public _appSetting: AppSettings,
    private _toastController: ToastController,
    public _appServices: AppService,
    private loggingService: LoggingService,
  ) {
    wrapAllMethodsWithLogging(this, this.componentName);
  }

  highlightWords(text: string): SafeHtml {
    if (!text) return '';

    const converted = text.replace(/\*\*(.*?)\*\*/g, '<span class="bold-text">$1</span>');

    return this.sanitizer.bypassSecurityTrustHtml(converted);
    // return text.replace(/\*\*(.*?)\*\*/g, '<span class="bold-text">$1</span>');
  }
  ngOnInit() {
    this.tryAgainGuide = false
    let deviceInfo = JSON.parse(this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.DeviceInfo)));
    const platform = this.platformService;
    const browser = deviceInfo.browser;
    if (platform.is('android')) {
      this.platform = 'android';
      this.browserType = 'Chrome';
      this.tabs = [

        { tabName: this.translate.instant('self_pwa_text.gps_text'), tabId: 0, visited: true },
        { tabName: this.translate.instant('self_pwa_text.gps_permission'), tabId: 1, visited: false },
        { tabName: this.translate.instant('self_pwa_text.check_browser'), tabId: 2, visited: false }
      ];
    } else if (platform.is('ios')) {
      this.platform = 'ios';
      this.browserType = browser === 'Safari' ? 'Safari' : 'Chrome';
      this.tabs = browser === 'Safari'
        ? [
          { tabName: this.translate.instant('self_pwa_text.gps_text'), tabId: 0 },
          { tabName: 'Check Website', tabId: 1 },
          { tabName: this.translate.instant('self_pwa_text.check_browser'), tabId: 2 }
        ]
        : [{ tabName: this.translate.instant('self_pwa_text.gps_text'), tabId: 0 }];
    } else {
      this.platform = 'unknown';
      this.tabs = [{ tabName: 'Tab 1', tabId: 0 }];
    }
    this.browserType = deviceInfo.browser
    this.key = JSON.parse(this.navParams.data.key);
    this.addresses = this.navParams.data.addresses;
    console.log("this.addresses", this.addresses)
  }

  closeModal() {
    this.modalCtrl.dismiss({});
    setTimeout(() => {
      this.permissionService.checkGeolocationPermission(false);
    }, 5000)
    // this.presentToast()
  }

  saveSelections() {
    const selectedItems = this.subObjects.filter(item => item.checked);
    // Do something with selected items (e.g., pass back to parent component)
    this.modalCtrl.dismiss(selectedItems);
  }

  goToSummary() {
    // Navigate to the Inspection Summary or trigger an action
    this.modalCtrl.dismiss({ action: 'summary' });
  }

  nextZoneCard() {
    // Navigate to the Next Zone Card or trigger an action
    this.modalCtrl.dismiss({ action: 'nextZone' });
  }

  tryAgain() {
    this.permissionService.checkGeolocationPermission();
  }

  toggleGif(val) {
    this.index = val;
    this.showGif = !this.showGif; // Toggle visibility
    setTimeout(() => {
      if (this.content) {
        this.content.scrollToBottom(500);
      } // Scroll smoothly to bottom
    }, 300);
  }

  onTabClick(index: any) {
    this.selectedTabIndex = index;
    this.tabs[this.selectedTabIndex].visited = true;
    this.showGif = false;
  }

  checking() {
    this.permissionService.permissionDenied$.pipe(take(1)).subscribe(permissionDenied => {
      if (permissionDenied) {
        // Mark the current tab as visited before finding the next incomplete tab
        this.tabs[this.selectedTabIndex].visited = true;

        // Find the next incomplete tab
        const nextIncompleteTabIndex = this.tabs.findIndex(tab => !tab.visited);

        if (nextIncompleteTabIndex !== -1) {
          // Move to the next incomplete tab
          this.selectedTabIndex = nextIncompleteTabIndex;
        } else {
          // All tabs are completed
          this.presentToast()
          this.steps = false;
          this.tryAgainGuide = true;
        }
        return;
      }
      this.closeModal();
    });
  }
  checkNow() {
    this.permissionService.checkGeolocationPermission(false);
    setTimeout(() => {
      this.checking();
    }, 100);
  }
  logActivity() {
    this.closeModal();
  }
  Refresh() {
    window.location.reload();
    this.closeModal();
  }
  async presentToast() {
    const toast = await this._toastController.create({
      message: 'Not able to verify your location.',
      duration: 3000,
      cssClass: 'custom-toast-error',
      position: "top",
    });
    toast.present();
  }
  tryagainpreviousstep() {
    this.steps = true;
    this.tryAgainGuide = false;
    this.selectedTabIndex = 0;
    this.tabs = this.tabs.map((tab, index) => ({
      ...tab,
      visited: index === 0 ? true : false
    }));
  }
}
